import { render, staticRenderFns } from "./AgeRequirementYearsInput.vue?vue&type=template&id=48020a58&"
import script from "./AgeRequirementYearsInput.vue?vue&type=script&lang=js&"
export * from "./AgeRequirementYearsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports